<style lang="stylus">
    .shepherd-element
        width 400px !important
        max-width 400px !important
        margin-top 4px
        border-radius 8px !important
        .shepherd-arrow
            // left -4px !important;
            // top -4px !important
        .shepherd-content
            border-radius 8px !important
    .shepherd-text
        padding 0 !important
        border-radius 8px !important
        overflow hidden
        .user-icon
            width 100%
    .shepherd-footer
        padding-bottom 16px
        border-bottom-left-radius 8px !important
        border-bottom-right-radius 8px !important
        .ok-shepherd
            position absolute !important
            left 16px !important
            color rgba(0, 0, 0, 0.5) !important
            font-size 12px !important
            background none !important
            padding 0.5rem 0 !important
        .btn-shepherd
            height 32px
            display flex
            justify-content center
            align-items center
            font-size 12px
            padding 0 20px
            font-weight 700
            border 2px solid transparent
            border-radius 50px
            background none
            color #000

        .prevbtn-shepherd
            background none !important
            &:hover
                background none !important
                border-color #000

        .nextbtn-shepherd
            border-color #000
            &:hover
                background #000 !important
                color #fff
</style>
<template></template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class EDShepherd extends Vue {
        // 新手指引
        initFlag = false;
        helpTipsTour = null;
        stayTime: number = 0;

        initShepherd() {
            this.stayTime = new Date().getTime();
            const self = this;
            if (!this.initFlag) {
                let createText = (num, title, content1, content2 = "") => {
                    let str = `<div style="padding: 16px 16px; line-height:16px">
                    <div style="display: flex;justify-content:space-between;margin-bottom:8px">
                        <p style="font-size:14px;color:#000;font-weight:700">${this.$t(title)}</p>
                        <p style="color:rgba(0, 0, 0, 0.6);font-size: 12px;white-space:nowrap">【 ${num}/5 】</p>
                    </div>
                    <div>
                        <p style="font-size:12px;color:#000;line-height:18px;margin-bottom:4px">${this.$t(content1)}</p>
                    </div>`;
                    if (content2) {
                        str += `
                        <div>
                            <p style="font-size:12px;color:#000;line-height:18px;margin-bottom:4px">${this.$t(content2)}</p>
                        </div></div>`;
                    } else {
                        str += "</div>";
                    }
                    return str;
                };
                let lang = this.lang == "zh" ? "cn" : "en";
                const imgList = {
                    help: this.internal ? require(`@/app/assets/img/helpGuide/help-${lang}.gif`) : require(`@/app/assets/img/helpGuide/help-en.gif`),
                    home: this.internal ? require(`@/app/assets/img/helpGuide/home-${lang}.gif`) : require(`@/app/assets/img/helpGuide/home-en.gif`),
                    library: this.internal
                        ? require(`@/app/assets/img/helpGuide/library-${lang}.gif`)
                        : require(`@/app/assets/img/helpGuide/library-en.gif`),
                    publish: this.internal
                        ? require(`@/app/assets/img/helpGuide/publish-${lang}.gif`)
                        : require(`@/app/assets/img/helpGuide/publish-en.gif`),
                    symbol: this.internal
                        ? require(`@/app/assets/img/helpGuide/symbol-${lang}.gif`)
                        : require(`@/app/assets/img/helpGuide/symbol-en.gif`),
                };
                let step = [
                    {
                        id: 0,
                        ele: "#libraryMenu .step-wrapper", // 符号库
                        pos: "right-start",
                        text: `<img src="${imgList.library}" alt="" class="user-icon isvip">${createText(
                            1,
                            "guide-1-title",
                            "guide-1-content1",
                            "guide-1-content2"
                        )}`,
                        params: { type: "mindShape" },
                    },
                    {
                        id: 1,
                        ele: "", // 修改样式
                        pos: "bottom",
                        text: `<img src="${imgList.symbol}" alt="" class="user-icon isvip">${createText(2, "guide-2-title", "guide-2-content1")}`,
                        params: { type: "mindShape" },
                    },
                    {
                        id: 2,
                        ele: "#tabpanel-btnbox .step-wrapper", // 分享
                        pos: "bottom-end",
                        text: `<img src="${imgList.publish}" alt="" class="user-icon isvip">${createText(
                            3,
                            "guide-3-title",
                            "guide-3-content1",
                            "guide-3-content2"
                        )}`,
                        params: { type: "mindShape" },
                    },
                    {
                        id: 3,
                        ele: "#back2home .step-wrapper", // 回到首页
                        pos: "bottom-start",
                        text: `<img src="${imgList.home}" alt="" class="user-icon isvip">${createText(4, "guide-4-title", "guide-4-content1")}`,
                        params: { type: "mindShape" },
                    },
                    {
                        id: 4,
                        ele: "#help-dropmenu .step-wrapper ", // 帮助
                        pos: "bottom",
                        text: `<img src="${imgList.help}" alt="" class="user-icon isvip">${createText(5, "guide-5-title", "guide-5-content1")}`,
                        params: { type: "mindShape" },
                    },
                ];
                this.helpTipsTour = this.$shepherd({
                    useModalOverlay: true,
                    defaultStepOptions: {
                        classes: "shepherd-tips",
                        highlightClass: "no-pointer",
                        popperOptions: {
                            modifiers: [
                                {
                                    name: "offset",
                                    options: {
                                        offset: [0, 12],
                                    },
                                },
                            ],
                        },
                    },
                });
                this.helpTipsTour.on("complete", () => {
                    localStorage.setItem("helpGuide", "1");
                    this.$bus.$emit("shepherdDone");
                    this.calcStayTime();
                    // 关闭帮助提示后更新接口数据
                });
                this.helpTipsTour.addStep({
                    attachTo: { element: step[0].ele, on: step[0].pos },
                    text: step[0].text,
                    buttons: [
                        {
                            classes: "ok-shepherd",
                            text: this.$t("okText"),
                            action: function () {
                                self.sensors.track("userGuidanceClick", {
                                    Catalogues: "openFileProcess",
                                    click_type: "skip",
                                });
                                this.complete();
                            },
                        },
                        {
                            classes: "nextbtn-shepherd btn-shepherd",
                            action: function () {
                                self.sensors.track("userGuidanceClick", {
                                    Catalogues: "openFileProcess",
                                    click_type: "next",
                                });
                                return this.next();
                            },
                            text: this.$t("nextText"),
                        },
                    ],
                });
                for (let item of step.filter((item) => ![0, 4].includes(item.id))) {
                    this.helpTipsTour.addStep({
                        attachTo: { element: item.ele, on: item.pos },
                        text: item.text,
                        buttons: [
                            {
                                classes: "ok-shepherd",
                                text: this.$t("okText"),
                                action: function () {
                                    self.sensors.track("userGuidanceClick", {
                                        Catalogues: "openFileProcess",
                                        click_type: "skip",
                                    });
                                    this.complete();
                                },
                            },
                            {
                                classes: "prevbtn-shepherd btn-shepherd",
                                action: function () {
                                    self.sensors.track("userGuidanceClick", {
                                        Catalogues: "openFileProcess",
                                        click_type: "back",
                                    });
                                    return this.back();
                                },
                                secondary: true,
                                text: this.$t("prevText"),
                            },
                            {
                                classes: "nextbtn-shepherd btn-shepherd",
                                action: function () {
                                    self.sensors.track("userGuidanceClick", {
                                        Catalogues: "openFileProcess",
                                        click_type: "next",
                                    });
                                    return this.next();
                                },
                                text: this.$t("nextText"),
                            },
                        ],
                    });
                }
                this.helpTipsTour.addStep({
                    attachTo: { element: step[4].ele, on: step[4].pos },
                    text: step[4].text,
                    buttons: [
                        {
                            classes: "prevbtn-shepherd btn-shepherd",
                            action: function () {
                                localStorage.setItem("helpGuide", "1");
                                this.show();
                                self.sensors.track("userGuidanceClick", {
                                    Catalogues: "openFileProcess",
                                    click_type: "again",
                                });
                            },
                            secondary: true,
                            text: this.$t("again"),
                        },
                        {
                            classes: "nextbtn-shepherd btn-shepherd",
                            action: function () {
                                this.complete();
                                localStorage.setItem("helpGuide", "1");
                                self.sensors.track("userGuidanceClick", {
                                    Catalogues: "openFileProcess",
                                    click_type: "start",
                                });
                            },
                            text: this.$t("done"),
                        },
                    ],
                });
                this.initFlag = true;
            }
            this.helpTipsTour.start();
        }
        get isPreviewView() {
            return this.$store.state.ui.isPreviewView;
        }

        calcStayTime() {
            let stayTime = (new Date().getTime() - this.stayTime) / 1000;
            this.stayTime = 0;
            this.sensors.track("userGuidanceTime", {
                Catalogues: "openFileProcess",
                guide_time: stayTime,
            });
        }

        mounted() {
            this.$bus.$on("showShepherd", () => {
                if (this.isPreviewView) {
                    return;
                }
                this.initShepherd();
            });
        }

        created() {}
        beforeDestroy() {
            this.$bus.$off("showShepherd");
        }
    }
</script>
<i18n>
{
  "zh": {
    "okText": "跳过",
    "nextText": "下一步",
    "prevText": "上一步",
    "done": "开始绘图",
    "again": "再看一遍",
    "guide-1-title": "找到合适的符号",
    "guide-1-content1": "选择你需要的符号添加到画布上。",
    "guide-1-content2": "要找到更多符号，请点击【更多符号】。",
    "guide-2-title": "修改符号样式",
    "guide-2-content1": "使用浮动工具栏修改符号样式、颜色、线条、文本等。",
    "guide-3-title": "发布和分享",
    "guide-3-content1": "点击【发布】，可以将你的作品发布到模板社区。",
    "guide-3-content2": "点击【分享】，可以将你的作品分享给他人，也可以直接分享到第三方社交平台。",
    "guide-4-title": "返回首页",
    "guide-4-content1": "在首页不仅可以选择绘图类型和模板，还可以进行导入Visio等相关操作。",
    "guide-5-title": "查看帮助教程",
    "guide-5-content1": "点击【帮助中心】，你可以在这里查看更多帮助教程"
  },
  "en": {
    "okText": "Skip",
    "nextText": "Next Step",
    "prevText": "Back",
    "done": "Start Drawing",
    "again": "Play Again",
    "guide-1-title": "Search for Symbols",
    "guide-1-content1": "Add the selected symbols to the drawing canvas.",
    "guide-1-content2": "Need more symbols? Please click [More Symbols].",
    "guide-2-title": "Customize Symbol Style",
    "guide-2-content1": "Go to the floating toolbar and adjust the selected symbol's style, color, lines, and text.",
    "guide-3-title": "Publish and Share",
    "guide-3-content1": "Click [Publish], and publish your diagram to EdrawMax Templates Community.",
    "guide-3-content2": "Click [Share], and share your diagram with others or on social media platforms.",
    "guide-4-title": "Back to Homepage",
    "guide-4-content1": "Click \"Back to homepage\" , where you can find various diagrams, use template and import,etc.",
    "guide-5-title": "Tutorial",
    "guide-5-content1": "Click [Help Center] and show more tutorials."
  },
  "fr": {
    "okText": "Sauter",
    "nextText": "Étape suivante",
    "prevText": "Retour",
    "done": "Commencer à dessiner",
    "again": "Relire",
    "guide-1-title": "Rechercher des symboles",
    "guide-1-content1": "Faites glisser et déposez les symboles sélectionnés dans la zone de dessin.",
    "guide-1-content2": "",
    "guide-2-title": "Personnaliser le style de symbole",
    "guide-2-content1": "Allez dans la barre d'outils flottante et ajustez le style, la couleur, les lignes et le texte du symbole sélectionné.",
    "guide-3-title": "Publier et partager",
    "guide-3-content1": "Cliquez sur &lt;Publier&gt;, et publiez votre diagramme dans la communauté des modèles EdrawMax.",
    "guide-3-content2": "Cliquez sur &lt;Partager&gt;, et partagez votre diagramme avec d'autres personnes ou sur des plateformes de réseaux sociaux.",
    "guide-4-title": "Retour à la page d'accueil",
    "guide-4-content1": "Click \"Back to homepage\" , where you can find various diagrams, use template and import,etc.",
    "guide-5-title": "Didactitiel",
    "guide-5-content1": "Cliquer sur Centre d'aide et trouver plus de tutos."
  },
  "de": {
    "okText": "Überspringen",
    "nextText": "Nächster Schritt",
    "prevText": "Zurück",
    "done": "Zeichnen starten",
    "again": "Nochmal abspielen",
    "guide-1-title": "Nach Symbolen suchen",
    "guide-1-content1": "Ziehen Sie ausgewählte Symbole per Drag-and-Drop auf die Zeichenfläche.",
    "guide-1-content2": "",
    "guide-2-title": "Symbolstil anpassen",
    "guide-2-content1": "Gehen Sie zur unverankerten Symbolleiste und passen Sie den Stil, die Farbe, die Linien und den Text des ausgewählten Symbols an.",
    "guide-3-title": "Veröffentlichen und teilen",
    "guide-3-content1": "Klicken Sie auf [Veröffentlichen] und veröffentlichen Sie Ihr Diagramm in der EdrawMax Vorlagen-Community.",
    "guide-3-content2": "Klicken Sie auf [Teilen] und teilen Sie Ihr Diagramm mit anderen oder auf Plattformen sozialer Medien.",
    "guide-4-title": "Zurück zur Homepage",
    "guide-4-content1": "Click \"Back to homepage\" , where you can find various diagrams, use template and import,etc.",
    "guide-5-title": "Tutorial",
    "guide-5-content1": "Klicken Sie auf [Hilfezentrum] und finden Sie weitere Tutorials."
  },
  "jp": {
    "okText": "スキップ",
    "nextText": "次へ",
    "prevText": "戻る",
    "done": "スタート",
    "again": "ガイドの再表示",
    "guide-1-title": "図形の検索",
    "guide-1-content1": "選択した図形を描画キャンバスにドラッグ＆ドロップします。",
    "guide-1-content2": "",
    "guide-2-title": "図形スタイルのカスタマイズ",
    "guide-2-content1": "フローティングツールバーを使用して、選択した図形のスタイル、色、線、テキスト等を変更できます。",
    "guide-3-title": "公開と共有",
    "guide-3-content1": "「公開」をクリックして、ダイアグラムをEdrawMaxテンプレートコミュニティに公開。",
    "guide-3-content2": "「共有」をクリックして、ダイアグラムを他のユーザーやSNSに共有。",
    "guide-4-title": "ホームに戻る",
    "guide-4-content1": "Click \"Back to homepage\" , where you can find various diagrams, use template and import,etc.",
    "guide-5-title": "チュートリアル",
    "guide-5-content1": "「ヘルプ」をクリックして、ユーザーガイド、チュートリアル等を確認できます。"
  },
  "es": {
    "okText": "Omitir",
    "nextText": "Siguiente Paso",
    "prevText": "Volver",
    "done": "Comenzar a Dibujar",
    "again": "Reproducir Nuevamente",
    "guide-1-title": "Búsqueda de Símbolos",
    "guide-1-content1": "Arrastra y suelta los símbolos seleccionados al lienzo de dibujo.",
    "guide-1-content2": "",
    "guide-2-title": "Personalizar el Estilo de los Símbolos",
    "guide-2-content1": "Ve a la barra de herramientas flotante y ajusta el estilo, el color, las líneas y el texto del símbolo seleccionado.",
    "guide-3-title": "Publicar y Compartir",
    "guide-3-content1": "Haz clic en [Publicar], y publica tu diagrama en la Comunidad de Plantillas de EdrawMax.",
    "guide-3-content2": "Haz clic en [Compartir] y comparte tu diagrama con otros o en las plataformas de las redes sociales.",
    "guide-4-title": "Volver a la Página de Inicio",
    "guide-4-content1": "Click \"Back to homepage\" , where you can find various diagrams, use template and import,etc.",
    "guide-5-title": "Tutorial",
    "guide-5-content1": "Haz clic en [Centro de Soporte] y encuentra más tutoriales."
  },
  "pt": {
    "okText": "Saltar",
    "nextText": "Passo Seguinte",
    "prevText": "De volta",
    "done": "Iniciar Desenho",
    "again": "Reproduzir de Novo",
    "guide-1-title": "Busca por Símbolos",
    "guide-1-content1": "Arraste e solte os símbolos selecionados na tela de desenho.",
    "guide-1-content2": "",
    "guide-2-title": "Personalizar o estilo do símbolo",
    "guide-2-content1": "Vá até à barra de ferramentas flutuante e ajuste o estilo, cor, linhas e texto do símbolo selecionado.",
    "guide-3-title": "Publicar e Compartilhar",
    "guide-3-content1": "Clique em [Publicar], e publique o seu diagrama na Comunidade de Modelos EdrawMax.",
    "guide-3-content2": "Clique em [Compartilhar] e compartilhe seu diagrama com outras pessoas ou em plataformas de mídia social.",
    "guide-4-title": "Voltar à Página Inicial",
    "guide-4-content1": "Click \"Back to homepage\" , where you can find various diagrams, use template and import,etc.",
    "guide-5-title": "Tutorial",
    "guide-5-content1": "Clique em [Centro de Ajuda] e encontre mais tutoriais."
  },
  "it": {
    "okText": "Salta",
    "nextText": "Passo Successivo",
    "prevText": "Indietro",
    "done": "Inizia a Disegnare",
    "again": "Guarda di Nuovo",
    "guide-1-title": "Cerca Simboli",
    "guide-1-content1": "Trascina e rilascia i simboli selezionati nell'area di disegno.",
    "guide-1-content2": "",
    "guide-2-title": "Personalizza lo Stile dei Simboli",
    "guide-2-content1": "Vai alla barra degli strumenti mobile e regola lo stile, il colore, le linee e il testo del simbolo selezionato.",
    "guide-3-title": "Pubblica e Condividi",
    "guide-3-content1": "Fare clic su [Pubblica] e pubblicare il diagramma nella community di modelli EdrawMax.",
    "guide-3-content2": "Fai clic su [Condividi] e condividi il tuo diagramma con altri o su piattaforme di social media.",
    "guide-4-title": "Torna alla Homepage",
    "guide-4-content1": "Click \"Back to homepage\" , where you can find various diagrams, use template and import,etc.",
    "guide-5-title": "Tutorial",
    "guide-5-content1": "Fare clic su [Centro Assistenza] e trovare altri tutorial."
  },
  "tw": {
    "okText": "跳過",
    "nextText": "下一步",
    "prevText": "後退",
    "done": "開始繪圖",
    "again": "再看一遍",
    "guide-1-title": "找到合適的符號",
    "guide-1-content1": "選擇你需要的符號新增到畫布上。",
    "guide-1-content2": "要找到更多符號，請點選【更多符號】。",
    "guide-2-title": "修改符號樣式",
    "guide-2-content1": "使用浮動工具欄修改符號樣式、顏色、線條、文字等。",
    "guide-3-title": "釋出和分享",
    "guide-3-content1": "點選【釋出】，可以將你的作品釋出到模板社群。",
    "guide-3-content2": "點選【分享】，可以將你的作品分享給他人，也可以直接分享第三方社交平臺。",
    "guide-4-title": "返回首頁",
    "guide-4-content1": "在首頁不僅可以選擇繪圖類型和模板，還可以進行導入Visio等相關操作",
    "guide-5-title": "檢視幫助教程",
    "guide-5-content1": "點選【幫助中心】，你可以在這裡檢視更多幫助教程。"
  }
}
</i18n>
